import React from 'react';
import { SourceType } from '@/modules/surgicalEvent';
import { SourceTypeTooltip } from './SourceTypeTooltip';
import { TranslatedText } from '@ianesthesie-kit/core';
import { styled } from '@mui/material/styles';

export const EpicBadge = () => (
  <div className="source-type-icon epic">
    <SourceTypeTooltip
      sourceType={SourceType.EPIC}
      title={<TranslatedText id="app.sourceType.EPIC.explanation" />}
    >
      <EpicBadgeIcon />
    </SourceTypeTooltip>
  </div>
);

export const EpicBadgeIcon = () => (
  <EpicLogoContainer>
    <img src="/epic-logo-filled-small.png" />
  </EpicLogoContainer>
);

const EpicLogoContainer = styled('div')`
  border-radius: 999px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -6px;
  left: -6px;
  width: 15px;
  height: 15px;
  z-index: 2;

  img {
    width: 22px;
    height: 22px;
  }
`;
